module.exports = __webpack_public_path__ + "reports.svg?09eceb09121ca1601d04b5e41f132008";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reports.svg
// module id = 320
// module chunks = 2